import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

export default gql`
  mutation SubmitV2ATransfer(
    $token: IdempotencyToken!
    $input: SubmitV2APaymentInput!
  ) {
    submitV2APayment(idempotencyId: $token, input: $input) {
      __typename
      ... on SubmitV2APaymentResultSuccess {
        __typename
        successTitle
        sentMessage
        educationMessage
      }

      ... on SubmitV2APaymentResultError {
        __typename
        ...error
      }
    }
  }
  ${error}
`;
